import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { toApiError } from "src/types/api";
export interface iWorkflowResultListState {
    response: any;
    isLoading: boolean;
    message: string | null;
    status: number | null; // 응답 상태 코드를 저장할 필드 추가
}

const initialState: iWorkflowResultListState = {
    response: null,
    isLoading: false,
    message: "",
    status: null, // 초기값 null
};

export const workFlowResultListAPI = createAsyncThunk(
    "workFlowResultListAPI",
    async (data: {
        group_name: string;
        library_name: string;
        round: number;
        workflow_name: string;
        step: number
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/result-list/';
            
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                workflow_name: data.workflow_name,
                group_name: data.group_name,
                library_name: data.library_name,
                round: data.round,
                step: data.step,
            });
            
            // 응답 객체에 상태 코드를 추가하여 반환
            return {
                data: response.data,
                status: response.status
            };
        } catch (error) {
            const apiError = toApiError(error);
            // 에러가 발생한 경우에도 상태 코드를 포함시킴
            return rejectWithValue({
                message: apiError.message,
                status: apiError.response?.status
            });
        }
    }
);

export const workFlowResultListSlice = createSlice({
    name: "workFlowResultList",
    initialState,
    reducers: {
        // 필요한 경우 여기에 리듀서 추가
        resetWorkflowResult: (state) => {
            state.response = null;
            state.status = null;
            state.message = "";
            state.isLoading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(workFlowResultListAPI.pending, (state) => {
                state.isLoading = true;
                state.status = null; // 요청 중에는 상태 코드 초기화
            })
            .addCase(workFlowResultListAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload.data; // 데이터만 response에 저장
                state.status = action.payload.status; // 상태 코드 저장
            })
            .addCase(workFlowResultListAPI.rejected, (state, action) => {
                state.isLoading = false;
                if (typeof action.payload === 'object' && action.payload !== null) {
                    state.message = (action.payload as any).message || "An error occurred";
                    state.status = (action.payload as any).status || null;
                } else {
                    state.message = action.payload as string || "An error occurred";
                }
            });
    }
});

// 액션 생성자 내보내기
export const { resetWorkflowResult } = workFlowResultListSlice.actions;

export default workFlowResultListSlice.reducer;
